import { useState } from "react";
import { Alert, Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../../api/axios";
import ProvinceSelect from "../Common/ProvinceSelect";

function Onboarding() {
  const navigate = useNavigate();
  const [handle, setHandle] = useState("");
  const [favoriteGame, setFavoriteGame] = useState("pokemon");
  const [location, setLocation] = useState({ city: "Madrid", province: "Madrid", postalCode: "" });
  const [acceptedLegal, setAcceptedLegal] = useState(false);
  const [acceptedUpdates, setAcceptedUpdates] = useState(false);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async event => {
    event.preventDefault();
    if (!acceptedLegal) {
      setError("Debes aceptar los terminos y la politica de privacidad.");
      return;
    }
    if (!location.city.trim() || (location.postalCode && !/^[0-9]{5}$/.test(location.postalCode))) {
      setError("Indica tu ciudad. Si añades codigo postal, debe tener 5 digitos.");
      return;
    }
    if (handle && !/^[a-zA-Z0-9_.-]{3,40}$/.test(handle)) {
      setError("El usuario debe tener entre 3 y 40 caracteres.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      const { data } = await api.post("/users/me/onboarding", {
        handle: handle.trim() || undefined,
        favoriteGames: [favoriteGame],
        preferences: { favoriteGameSlug: favoriteGame },
        city: location.city.trim(),
        province: location.province,
        postalCode: location.postalCode,
        country: "España",
        acceptedLegal,
        acceptedUpdates
      });
      if (data) localStorage.setItem("user", JSON.stringify(data));
      navigate("/binder", { replace: true });
    } catch (requestError) {
      setError(requestError?.response?.data?.error || "No pudimos guardar tus preferencias.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container className="page-band">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="cardora-card">
            <Card.Body>
              <h1 className="section-title mb-2">Prepara tu Cardora</h1>
              <p className="muted-copy mb-4">Completa estos datos para personalizar tu binder y tus primeras sugerencias.</p>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={submit}>
                <Form.Group className="mb-3" controlId="onboardingHandle">
                  <Form.Label>Usuario público</Form.Label>
                  <Form.Control value={handle} onChange={event => setHandle(event.target.value)} placeholder="tomas_cardora" maxLength={40} autoComplete="username" />
                  <Form.Text className="muted-copy">Opcional. Se usará para compartir tu perfil.</Form.Text>
                </Form.Group>
                <Row className="g-3 mb-3">
                  <Col sm={6}><Form.Group controlId="onboardingCity"><Form.Label>Ciudad o municipio</Form.Label><Form.Control required value={location.city} onChange={event => setLocation(current => ({ ...current, city: event.target.value }))} autoComplete="address-level2" /></Form.Group></Col>
                  <Col sm={6}><Form.Group controlId="onboardingProvince"><Form.Label>Provincia <span className="muted-copy">(opcional)</span></Form.Label><ProvinceSelect value={location.province} onChange={event => setLocation(current => ({ ...current, province: event.target.value }))} /></Form.Group></Col>
                  <Col sm={6}><Form.Group controlId="onboardingPostalCode"><Form.Label>Codigo postal <span className="muted-copy">(privado)</span></Form.Label><Form.Control inputMode="numeric" maxLength={5} value={location.postalCode} onChange={event => setLocation(current => ({ ...current, postalCode: event.target.value.replace(/\D/g, "").slice(0, 5) }))} autoComplete="postal-code" /><Form.Text className="muted-copy">Solo mejora la cercania; no se muestra publicamente.</Form.Text></Form.Group></Col>
                  <Col sm={6}><Form.Group><Form.Label>Pais</Form.Label><Form.Control value="España" disabled readOnly /></Form.Group></Col>
                </Row>
                <Form.Group className="mb-4" controlId="onboardingGame">
                  <Form.Label>Juego principal</Form.Label>
                  <Form.Select value={favoriteGame} onChange={event => setFavoriteGame(event.target.value)}>
                    <option value="pokemon">Pokémon</option>
                    <option value="magic">Magic: The Gathering</option>
                    <option value="one_piece">One Piece</option>
                    <option value="yugioh">Yu-Gi-Oh!</option>
                  </Form.Select>
                </Form.Group>
                <Form.Check className="mb-2" type="checkbox" id="onboardingLegal" checked={acceptedLegal} onChange={event => setAcceptedLegal(event.target.checked)} label="Acepto los terminos y la politica de privacidad." />
                <Form.Check className="mb-4" type="checkbox" id="onboardingUpdates" checked={acceptedUpdates} onChange={event => setAcceptedUpdates(event.target.checked)} label="Quiero recibir avisos de matches y eventos." />
                <Button type="submit" className="btn-cardora w-100" disabled={saving}>
                  {saving ? "Guardando..." : "Continuar al binder"}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Onboarding;
